import React, { useState, useEffect } from 'react';
import { auth } from './components/Login/Firebase';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import StateProvider from './components/StateProvider';

// Hoilday Effects
// import Snowfall from './components/Utilities/components/Snowfall/index.js';

// Access & Nav/Dashboard
import Login from './components/Login/index.js';
import Landing from './components/Landing/index.js';
import Dashboard from './components/Dashboard/index.js';
import Navigation from './components/Navigation/index.js';
import Registration from './components/Login/Registration/index.js';
import ResetPassword from './components/Login/ResetPassword/index.js';

// General Pages
import About from './components/Pages/About/index.js';
import Franchise from './components/Pages/Franchise/index.js';
import Locations from './components/Pages/Locations/index.js';
import Career from './components/Pages/Career/index.js';
import ApplicantInquiry from './components/Pages/Career/ApplicantInquiry/index.js';
import ApplicantTraining from './components/Pages/Career/ApplicantTraining/index.js';
import ExamForm from './components/Pages/ExamForm/index.js';
import Exam from './components/Pages/Exam/index.js';
import ExamResult from './components/Pages/ExamResult/index.js';
import Blog from './components/Pages/Blog/index.js';
import FAQs from './components/Pages/FAQs/index.js';
import ServicesPricing from './components/Pages/ServicesPricing/index.js';
import DogServicesPricing from './components/Pages/ServicesPricing/DogServicesPricing/index.js';
import CatServicesPricing from './components/Pages/ServicesPricing/CatServicesPricing/index.js';

// Legal Components
import TermsAndConditions from './components/Pages/Legal/TermsAndConditions.js';
import PrivacyPolicy from './components/Pages/Legal/PrivacyPolicy.js';

// User Components
import Profile from './components/Dashboard/Profile/index.js';
import ProfileCompletePage from './components/Dashboard/Profile/components/ProfileCompletePage/index.js';
import ProfileEdit from './components/Dashboard/Profile/components/EditProfile';
import UserEdit from './components/Dashboard/Profile/components/EditProfile/userEdit';
import FamilyMemberEdit from './components/Dashboard/Profile/components/EditProfile/FamilyMemberEdit';
import FamilyMemberAdd from './components/Dashboard/Profile/components/EditProfile/FamilyMemberAdd';
import Cart from './components/Dashboard/Cart';
import Checkout from './components/Dashboard/Cart/Checkout';
import Friends from './components/Dashboard/Profile/components/Friends/index.js';
import Membership from './components/Dashboard/Profile/components/Membership/index.js';
import MembershipEdit from './components/Dashboard/Profile/components/Membership/MembershipEdit/index.js';
import Wallet from './components/Dashboard/Profile/components/Wallet/index.js';
import PaymentMethods from './components/Dashboard/Profile/components/Wallet/PaymentMethods/index.js';
import AddPaymentMethod from './components/Dashboard/Profile/components/Wallet/PaymentMethods/AddPaymentMethod/index.js';
import EditPaymentMethod from './components/Dashboard/Profile/components/Wallet/PaymentMethods/EditPaymentMethod/index.js';
import PaymentHistory from './components/Dashboard/Profile/components/Wallet/PaymentHistory/index.js';
import PaymentDetails from './components/Dashboard/Profile/components/Wallet/PaymentHistory/PaymentDetails/index.js';

// Store Components
import Store from './components/Store';
import Hotel from './components/Store/Services/Hotel';
import Shuttle from './components/Store/Services/Shuttle';
import Daycare from './components/Store/Services/Daycare';
import Grooming from './components/Store/Services/Grooming';
import Training from './components/Store/Services/Training';
import Adventure from './components/Store/Services/Adventure';
import HotelBooking from './components/Store/Services/Hotel/HotelBooking';
import DaycareBooking from './components/Store/Services/Daycare/DaycareBooking';
import ShuttleBooking from './components/Store/Services/Shuttle/ShuttleBooking';
import GroomingBooking from './components/Store/Services/Grooming/GroomingBooking';
import TrainingBooking from './components/Store/Services/Training/TrainingBooking';
import AdventureBooking from './components/Store/Services/Adventure/AdventureBooking';
import MembershipBooking from './components/Store/Services/Membership/MembershipBooking';
import BundleBooking from './components/Store/Services/Bundles/BundleBooking';

// User Empower
import Invite from './components/Store/Services/Deals/Invite';
import Impact from './components/Store/Services/Deals/Impact';
import GiftCard from './components/Store/Services/Deals/GiftCard';
import BuyGiftCard from './components/Store/Services/Deals/GiftCard/BuyGiftCard';

// Dashboard Components
import Events from './components/Dashboard/Events/index.js';
import Support from './components/Dashboard/Support/index.js';

// Utils
import ComingSoon from './components/Utilities/components/ComingSoon/index.js';
import QRCode from './components/Utilities/components/QRCode/index.js';
// import OpenInBrowserPrompt from './components/Utilities/components/OpenInBrowserPrompt/index.js';
import MobileAccessPrompt from './components/Utilities/components/MobileAccessPrompt/index.js';

// Team Console
import Console from './components/Console/index.js';
import TeamSupport from './components/Console/components/AdminDashboard/AdminSupport/index.js';

import TeamPets from './components/Console/components/Clients/index.js';
import TeamUserInfo from './components/Console/components/Clients/UserInfo/index.js';
import TeamPetInfo from './components/Console/components/Clients/PetInfo/index.js';
import TeamUserBookingInfo from './components/Console/components/Clients/BookingInfo/index.js';
import TeamUserPaymentHistory from './components/Console/components/Clients/PaymentHistory/index.js';
import TeamUserPaymentDetails from './components/Console/components/Clients/PaymentDetails/index.js';

import TeamTasks from './components/Console/components/Tasks/index.js';
import AdminTasks from './components/Console/components/Tasks/roles/AdminTasks/index.js';
import AdminTaskAssignments from './components/Console/components/Tasks/roles/AdminTasks/components/TaskAssignments/index.js';
import AdminIncidentLog from './components/Console/components/IncidentLogs/AdminIncidentLogs/index.js';
import AdminStaffAndSchedule from './components/Console/components/Tasks/roles/AdminTasks/components/StaffAndSchedule/index.js';
import GroomerTasks from './components/Console/components/Tasks/roles/GroomerTasks/index.js';
import TeamGroomerAppointments from './components/Console/components/Tasks/roles/GroomerTasks/GroomerAppointments/index.js';
import TeamGroomerAppointmentDetail from './components/Console/components/Tasks/roles/GroomerTasks/GroomerAppointments/GroomingAppointmentDetail/index.js';
import ReceptionTasks from './components/Console/components/Tasks/roles/ReceptionTasks/index.js';
import ReceptionBookings from './components/Console/components/Tasks/roles/ReceptionTasks/components/ReceptionBookings.js';
import ReceptionCreateBooking from './components/Console/components/Tasks/roles/ReceptionTasks/components/ReceptionCreateBooking.js';
import ReceptionPayments from './components/Console/components/Tasks/roles/ReceptionTasks/components/ReceptionPayments.js';
import ReceptionCheckInOut from './components/Console/components/Tasks/roles/ReceptionTasks/components/ReceptionCheckInOut.js';
import ReceptionMemberships from './components/Console/components/Tasks/roles/ReceptionTasks/components/ReceptionMemberships.js';
import ReceptionShuttle from './components/Console/components/Tasks/roles/ReceptionTasks/components/ReceptionShuttle.js';
import ReceptionRetail from './components/Console/components/Tasks/roles/ReceptionTasks/components/ReceptionRetail.js';

import TeamGuides from './components/Console/components/Guides/index.js';
import TeamConceptDetailPage from './components/Console/components/Guides/GuideDetail/CoreConceptDetails/index.js';
import TeamSOPConceptDetailPage from './components/Console/components/Guides/SOPDetail/CoreConceptDetails/index.js';

import TeamIncidentLog from './components/Console/components/IncidentLogs/index.js';

import TeamPromotions from './components/Console/components/Promotions/index.js';

import TeamClockInAndOut from './components/Console/components/Clock/index.js';

import TeamTraining from './components/Console/components/Training/index.js';

import TeamPerformance from './components/Console/components/Performance/index.js';

import TeamPayStubs from './components/Console/components/PayStubs/index.js';

import TeamEvents from './components/Console/components/Events/index.js';

import LiveChargeTest from './components/Console/components/Payments/LiveChargeTest/index.js';
import ServerLogs from './components/Console/components/ServerLogs/index.js';

import stripePromise from './stripe';
import { Elements } from '@stripe/react-stripe-js';

function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [role, setRole] = useState('');

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      if (user) {
        // User is signed in.
        setLoggedIn(true);
      } else {
        // User is signed out.
        setLoggedIn(false);
      }
    });

    // Clean up the subscription
    return () => unsubscribe();
  }, []);

  return (
    <Router>
      <Elements stripe={stripePromise}>
        <StateProvider loggedIn={loggedIn} setLoggedIn={setLoggedIn} setRole={setRole} role={role} >
          <Navigation />
          {/* <OpenInBrowserPrompt /> */}
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Registration />} />
            <Route path="/oauth-registration" element={<Registration />} />
            <Route path="/resetPassword" element={<ResetPassword />} />

            <Route path="/about" element={<About />} />
            <Route path="/franchise" element={<Franchise />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/career" element={<Career />} />
            <Route path="/career/applicant-inquiry" element={<ApplicantInquiry />} />
            <Route path="/career/applicant-onboarding" element={<ApplicantTraining />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/service-prices" element={<ServicesPricing />} />
            <Route path="/service-prices/dog" element={<DogServicesPricing />} />
            <Route path="/service-prices/cat" element={<CatServicesPricing />} />
            
            <Route path="/exam-form" element={<ExamForm />} />
            <Route path="/exam/:userType" element={<Exam />} />
            <Route path="/exam/result" element={<ExamResult />} />

            <Route path="/legal/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
            
            <Route path="/qr-code" element={<QRCode />} />
            <Route path="/coming-soon" element={<ComingSoon />} />

            <Route path="/store" element={<Store />} />
                <Route path="/store/services/hotel" element={<Hotel />} />
                <Route path="/store/services/shuttle" element={<Shuttle />} />
                <Route path="/store/services/daycare" element={<Daycare />} />
                <Route path="/store/services/grooming" element={<Grooming />} />
                <Route path="/store/services/training" element={<Training />} />
                <Route path="/store/services/adventure" element={<Adventure />} />
                <Route path="/store/membership" element={<MembershipBooking />} />
                <Route path="/store/bundle" element={<BundleBooking />} />
                
            {loggedIn && (
              <>
                <Route path="/profile" element={<Profile />} />
                <Route path="/profile/complete" element={<ProfileCompletePage />} />
                <Route path="/profile/edit-profile" element={<ProfileEdit />} />
                <Route path="/profile/edit-family-member/user" element={<UserEdit />} />
                <Route path="/profile/edit-family-member/:memberType/:memberId" element={<FamilyMemberEdit />} />
                <Route path="/profile/edit-family-member/add-family-member" element={<FamilyMemberAdd />} />
                <Route path="/profile/friends" element={<Friends />} />
                <Route path="/profile/membership" element={<Membership />} />
                <Route path="/profile/membership/update/:membershipId" element={<MembershipEdit />} />
                <Route path="/profile/wallet" element={<Wallet />} />
                <Route path="/profile/wallet/payment-methods" element={<PaymentMethods />} />
                <Route path="/profile/wallet/payment-methods/add-payment" element={<AddPaymentMethod />} />
                <Route path="/profile/wallet/payment-methods/edit-payment/:id" element={<EditPaymentMethod />} />
                <Route path="/profile/wallet/payment-history" element={<PaymentHistory />} />
                <Route path="/profile/wallet/payment-history/:transactionId" element={<PaymentDetails />} />
                <Route path="/profile/cart" element={<Cart />} />
                <Route path="/profile/checkout" element={<Checkout />} />

                <Route path="/store/deals/invite" element={<Invite />} />
                <Route path="/store/deals/impact" element={<Impact />} />
                <Route path="/store/deals/gift-card" element={<GiftCard />} />

                <Route path="/store/services/gift-card-purchase" element={<BuyGiftCard />} />
                <Route path="/store/services/hotel/booking" element={<HotelBooking />} />
                <Route path="/store/services/daycare/booking" element={<DaycareBooking />} />
                <Route path="/store/services/shuttle/booking" element={<ShuttleBooking />} />
                <Route path="/store/services/grooming/booking" element={<GroomingBooking />} />
                <Route path="/store/services/training/booking" element={<TrainingBooking />} />
                <Route path="/store/services/adventure/booking" element={<AdventureBooking />} />

                <Route path="/events" element={<Events />} />

                <Route path="/support" element={<Support />} />
              </>
            )}

            {/* Accessible to all for applicants */}
            <Route path="/console/guides/:detailKey" element={<TeamConceptDetailPage />} />

            {/* {loggedIn && (role === 'admin' || role === 'staff') && ( */}
                <>
                  <Route path="/console" element={<Console />} />
                  <Route path="/console/support" element={<TeamSupport />} />

                  <Route path="/console/server-logs" element={<ServerLogs />} />

                  <Route path="/console/pets" element={<TeamPets />} />
                  <Route path="/console/userInfo/:userId" element={<TeamUserInfo />} />
                  <Route path="/console/petInfo/:petId" element={<TeamPetInfo />} />
                  <Route path="/console/userBookingInfo/:userId" element={<TeamUserBookingInfo />} />
                  <Route path="/console/userPaymentHistory/:userId" element={<TeamUserPaymentHistory />} />
                  <Route path="/console/userPaymentDetails/:userId/:transactionId" element={<TeamUserPaymentDetails />} />
                  
                  <Route path="/console/tasks" element={<TeamTasks />} />
                  <Route path="/console/tasks/admin" element={<AdminTasks />} />
                  <Route path="/console/tasks/admin/task-assignments" element={<AdminTaskAssignments />} />
                  <Route path="/console/tasks/admin/staff-and-schedule" element={<AdminStaffAndSchedule />} />
                  <Route path="/console/tasks/admin/incident-log" element={<AdminIncidentLog />} />
                  <Route path="/console/tasks/groomer" element={<GroomerTasks />} />
                  <Route path="/console/tasks/groomer-appointments" element={<TeamGroomerAppointments />} />
                  <Route path="/console/tasks/groomer-appointment-detail/:id" element={<TeamGroomerAppointmentDetail />} />
                  <Route path="/console/tasks/reception" element={<ReceptionTasks />} />
                  <Route path="/console/tasks/reception/reception-bookings" element={<ReceptionBookings />} />
                  <Route path="/console/tasks/reception/reception-bookings/create" element={<ReceptionCreateBooking />} />
                  <Route path="/console/tasks/reception/reception-payments" element={<ReceptionPayments />} />
                  <Route path="/console/tasks/reception/reception-check-ins" element={<ReceptionCheckInOut />} />
                  <Route path="/console/tasks/reception/reception-memberships" element={<ReceptionMemberships />} />
                  <Route path="/console/tasks/reception/reception-shuttle" element={<ReceptionShuttle />} />
                  <Route path="/console/tasks/reception/reception-retail" element={<ReceptionRetail />} />
                  
                  <Route path="/console/guides" element={<TeamGuides />} />
                  <Route path="/console/sop/:detailKey" element={<TeamSOPConceptDetailPage />} />

                  <Route path="/console/incident-log" element={<TeamIncidentLog />} />

                  <Route path="/console/promotions" element={<TeamPromotions />} />

                  <Route path="/console/clockInAndOut" element={<TeamClockInAndOut />} />

                  <Route path="/console/training" element={<TeamTraining />} />

                  <Route path="/console/performance" element={<TeamPerformance />} />

                  <Route path="/console/paystubs" element={<TeamPayStubs />} />

                  <Route path="/console/events" element={<TeamEvents />} />

                  <Route path="/console/test-charges" element={<LiveChargeTest />} />
                </>
            {/* )} */}
          </Routes>

          {loggedIn && <Dashboard />}
        </StateProvider>

        <MobileAccessPrompt />
      </Elements>
    </Router>
  );
}

export default App;
